import React, { Component } from 'react';
import { Grid, Segment, Divider, Card, Image, Button } from 'semantic-ui-react'

class KitengeSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kitengeSelected: 'None',
            showKitenge:false
        }
    }

    componentDidMount(){
        console.log("kitx01 +++++++KitengeSelector  componentDidMount");
        console.log("kitx02 this.props.itemType :"+this.props.itemType );
        console.log("kitx03 this.props.kitenge:"+this.props.kitenge);

    }

    selectYellowBrownKitenge = () => {
        console.log("kitx1 +++++++++ selectYellowBrownKitenge");
        console.log("kitx12 - this.props.arrayIndex:" + this.props.arrayIndex);


        this.props.updateOrderArray(this.props.arrayIndex, 'kitengeType', 'yellowBrown');

        this.setState({
            kitengeSelected: 'yellowBrown'
        })
    }

    selectZebraPrint = () => {
        console.log("kitx1 +++++++++ selectYellowBrownKitenge");
        console.log("kitx12 - this.props.arrayIndex:" + this.props.arrayIndex);


        this.props.updateOrderArray(this.props.arrayIndex, 'kitengeType', 'zebraPrint');

        this.setState({
            kitengeSelected: 'zebraPrint'
        })
    }

    selectBlueRed = () => {
        console.log("kitx1 +++++++++ selectYellowBrownKitenge");
        console.log("kitx12 - this.props.arrayIndex:" + this.props.arrayIndex);


        this.props.updateOrderArray(this.props.arrayIndex, 'kitengeType', 'blueRed');

        this.setState({
            kitengeSelected: 'blueRed'
        })
    }

    selectOrangeBrown = () => {
        console.log("kitx1 +++++++++ selectOrangeBrown");
        console.log("kitx12 - this.props.arrayIndex:" + this.props.arrayIndex);


        this.props.updateOrderArray(this.props.arrayIndex, 'kitengeType', 'orangeBrown');

        this.setState({
            kitengeSelected: 'orangeBrown'
        })
    }

    showKitenge = () => {
        console.log("kitx1 +++++++++ showKitenge");
        this.setState({
            showKitenge:true
        })
    }

    render() {


        const YellowBrown = () => (
            <Card onClick={this.selectYellowBrownKitenge}>
                <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fkitenge%2Fkitenge_yellow_brown100.jpg?alt=media&token=915e383f-423e-48c8-9524-33fac6b76991' />
            </Card>
        )

        const ZebraPrint = () => (
            <Card onClick={this.selectZebraPrint}>
                <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fkitenge%2Fkitenge_zebra100.jpg?alt=media&token=1c201055-9653-42e0-87bc-db8ca2dc9ccd' />
            </Card>
        )

        const BlueRed = () => (
            <Card onClick={this.selectBlueRed}>
                <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fkitenge%2Fkitenge_blueRed100.jpg?alt=media&token=d5b3a2e5-4586-41c0-ba18-fd9107a5ede0' />
            </Card>
        )

        const OrangeBrown = () => (
            <Card onClick={this.selectOrangeBrown}>
                <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fkitenge%2Fkitenge_orange_brown.jpg?alt=media&token=06abecbf-aa05-4d3c-a44e-0925dee0cbf1' />
            </Card>
        )

        const KitengeSelectionGrid = () => (
            <Grid columns='equal'>
                <Grid.Column>
                    <YellowBrown />
                </Grid.Column>
                <Grid.Column >
                    <ZebraPrint />
                </Grid.Column>
                <Grid.Column>
                    <OrangeBrown />
                </Grid.Column>
            </Grid>
        )

        const tshirtKitengePrompt = this.props.itemType === 't-shirts' && this.props.kitenge === false
            ? <div>
                <Divider horizontal>OPTIONAL</Divider>
                <Divider horizontal>Add Kitenge to the sleeves of your t-shirt?</Divider>
                <Divider horizontal>Kitenge is 10,000 UGX EXTRA, TAKES 2-3 DAYS</Divider>
                {/* <Card >
                    <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fkitenge%2Fkitenge_onlyOnSleeves400.jpg?alt=media&token=cc1cc25e-602f-4293-be79-73e8a46e57fe' />
                </Card> */}
                <Button onClick={this.showKitenge}> ADD KITENGE </Button>
            </div>
            : ''

        const kitengeButton = this.props.itemType === 't-shirts' && this.props.kitenge  === false
            ? <div>
                <Button onClick={this.showKitenge}> ADD KITENGE </Button>
            </div>
            :''

        const showKitengeUi = this.props.kitenge || this.state.showKitenge
            ? <div>
                <Divider horizontal>SELECT YOUR KITENGE: {this.state.kitengeSelected}</Divider>
                <KitengeSelectionGrid />
              </div>
            :''

        return (
            <div>

                {tshirtKitengePrompt}
                {showKitengeUi}
                
                <br />
            </div>
        )
    }
}

export default KitengeSelector;


// WEBPACK FOOTER //
// ./src/components/newSite/Kitenge/KitengeSelector.js